<template>
  <div class="contract">
    <mt-header title="签署文件">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
      <a @click="backhome()" slot="left" class="backhome">关闭</a>
      <a @click="sendContract()" slot="right">
        发送
      </a>
    </mt-header>
    <div class="addsigndiv">
      <div class="fl">
        <mt-button size="small" type="default" @click="addsigner()">
          <img src="/static/img/contract/add2.png" height="20" width="20" slot="icon">
          添加签署人
        </mt-button>
      </div>
      <div class="fl fromcontact">
        <mt-button size="small" type="default" @click="addsignerfrom()">
          <img src="/static/img/contract/add2.png" height="20" width="20" slot="icon">
          联系人列表添加
        </mt-button>
      </div>
    </div>
    <hr>
    <div class="addcontain">
      <div class="addsigner" v-for="(item,index) in signerlist">
        <div class="fl userimg">
          <img src="/static/img/contract/signer.png">
        </div>
        <div class="fl">
          <div class="signname">
            {{item.name}}
          </div>
          <div class="signmobile">
            {{item.mobile}}
          </div>
        </div>
        <div class="fr signerdelimg" @click="delSigner(index)">
          <img src="/static/img/user/sign/delete.png">
        </div>
        <div class="cl"></div>
      </div>
    </div>
  </div>
</template>

<script> 
import { Toast } from 'mint-ui';
import cheader from '@/components/header';
export default {
  data () {
    return {
      mymobile:'',
      signerlist:'',
      nameArray:[],
      mobileArray:[],
      emailArray:[],
      cid:this.$route.query.cid
    }
  },
  mounted(){
    this.signerlist = this.$route.query.signerlist;
    if(this.signerlist != null && this.signerlist != "" && typeof(this.signerlist) != "undefined"  && this.signerlist != "[]"){
      this.signerlist = eval(this.signerlist);
    }else{
      this.signerlist = new Array();
    }
    var that = this;
    this.$http.post(
        domain("_getMobile")
    )
    .then(function(response){
        that.mymobile = response.data.data.loginCode;
        },function(error){
          console.log(error);
    });
    // if(this.signerlist[0]!=null && this.signerlist[0]!=""){
    //   this.$http.post(
    //       domain("_isAddSignered"),
    //       {
    //           'contractId':this.cid,
    //           'mobile':this.signerlist[0].mobile
    //       }
    //   )
    //   .then(function(response){
    //       if(response.data.code=='998'){
    //         	that.$router.push("/main");
    //       }
    //   },function(error){
    //       console.log(error);
    //   });
    // }
  },
  methods: {
    addsigner: function(){
      this.$router.push({name: 'savesigner', query:{'cid': this.cid,'signerlist': JSON.stringify(this.signerlist)}});
    },
    addsignerfrom: function(){
      this.$router.push({name: 'fromcontact', query:{'cid': this.cid,'signerlist': JSON.stringify(this.signerlist)}});
    },
    sendContract: function(){
      this.nameArray = new Array();
      this.mobileArray = new Array(); 
      this.emailArray = new Array();  
      var that = this;
      if(this.signerlist.length==0){
        this.$toast("请添加签署人");
        return;
      }
      var cpmb = new Array();
      for(var i=0;i<this.signerlist.length;i++){
        this.nameArray.push(this.signerlist[i].name);
        this.mobileArray.push(this.signerlist[i].mobile);
        this.emailArray.push(this.signerlist[i].email);
        cpmb.push(this.signerlist[i].mobile);
      }
      cpmb.sort();
      var cp = 0;
      for(var j=0;j<cpmb.length;j++){
        if(cpmb[j] == this.mymobile){
          cp = 2;
          break;
        }
        if(cpmb[j]==cpmb[j+1]){
          cp = 1;
          break;
        }
      }
      if(cp == 1){
        that.$toast("您添加的联系人手机号重复!");
        return;
      }else if(cp == 2){
        that.$toast("您不能添加自己的手机号!");
        return;
      }
      that.$http.post(
          domain("_addSigner"),
          {
            'contractId':this.cid,
            'name':JSON.stringify(this.nameArray),
            'mobile':JSON.stringify(this.mobileArray),
            'mail':JSON.stringify(this.emailArray)
          }
      )
      .then(function(response){
        console.log(response);
          if(response.data.code == "0"){
            this.$toast({
              message: '发送成功',
              iconClass: 'mintui mintui-success'
            });
            this.$router.push('/main');
          }else{
            that.$toast("发送失败");
          }  
          },function(error){
            console.log(error);
      })
    },
    delSigner :function(index){
      this.signerlist.splice(index,1);
      this.$router.push({name: 'addsigner', query:{'signerlist':JSON.stringify(this.signerlist),'cid':this.cid}});
    },
    goback: function () {
    //   history.go(-1); //后退1页
        this.$router.push("/main");
    },
    backhome: function () {
      this.$router.push('/main');
    }
  },
  components:{
     cheader
  }
}
</script>
<style>
.addcontain{
  padding: 0 10px;
}
.addsigndiv{
  padding: 0 10px;
  height:50px;
  padding-top: 20px;
  background-color: #ffffff;
}
.addsigner{
  height:60px;
  margin-top: 20px;
}
.signname{
  font-size: 0.9rem;
  color: #7d7d7d;
  text-align: left;
  margin: 8px 0 0 15px; 
}
.signmobile{
  font-size: 0.9rem;
  color: #c1c1c1;
  text-align: left;
  margin: 5px 0 0 15px;
}
.checktop{
  margin-top:20px;
}
.userimg img{
  width:40px;
  margin-top: 9px;
}
.signerdelimg img{
  width:18px;
  margin: 20px 5px 0 0;
}
.fromcontact{
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/module/contract/AddSigner.vue